import useSWRImmutable from 'swr/immutable';
import { IErrorResponse } from '@belong/types/api/generic';
import { IMobileDataProductsResponse, IMobileProductsResponse } from '@belong/types/api/products';
import { PRODUCT_FAMILY } from '@belong/types/product';
import { transformSWRError } from '../../helpers';
import { isValidProductFamily } from './helpers';
import { loadMobileProducts } from './loaders';
import { ProductAvailabilityFilter } from './types';

export interface IUseMobileProducts {
  isLoading: boolean;
  error?: IErrorResponse;
  products?: IMobileProductsResponse | IMobileDataProductsResponse;
}

export const getCacheKey = (productFamily?: PRODUCT_FAMILY, journey?: ProductAvailabilityFilter): string | null => {
  if (!productFamily) {
    return null;
  }

  // If invalid productFamily clear cache key to prevent data loading
  if (!isValidProductFamily(productFamily)) {
    return null;
  }

  const key = productFamily.replaceAll(/\s*/g, '');
  return journey ? `${key}/${journey}` : key;
};

export const useMobileProducts = (
  productFamily: PRODUCT_FAMILY,
  filter?: ProductAvailabilityFilter
): IUseMobileProducts => {
  const cacheKey = getCacheKey(productFamily, filter);
  const result = useSWRImmutable(cacheKey, async () => loadMobileProducts(productFamily, filter));

  return {
    isLoading: result.isLoading,
    error: transformSWRError(result),
    products: result.data
  };
};
